import { Bell, Settings, User, Search } from 'lucide-react';
import { useState } from 'react';
import { useLocation } from 'wouter';
import { Button } from '@/components/ui/button';
import { Avatar, AvatarFallback, AvatarImage } from '@/components/ui/avatar';
import { Input } from '@/components/ui/input';

interface DashboardHeaderProps {
  userData: any;
}

export default function DashboardHeader({ userData }: DashboardHeaderProps) {
  const [, navigate] = useLocation();
  const [searchQuery, setSearchQuery] = useState('');

  // Extraer primera letra del nombre para el avatar
  const getInitials = () => {
    if (userData?.user_metadata?.name) {
      return userData.user_metadata.name.charAt(0).toUpperCase();
    }
    return 'U';
  };

  const handleSearch = (e: React.FormEvent) => {
    e.preventDefault();
    // Implementar lógica de búsqueda
    console.log('Buscando:', searchQuery);
  };

  return (
    <header className="bg-zinc-900/90 backdrop-blur-sm border-b border-white/10 sticky top-0 z-50">
      <div className="container mx-auto px-4 py-3">
        <div className="flex items-center justify-between gap-4">
          {/* Logo y título */}
          <div className="flex items-center gap-4">
            <div
              onClick={() => navigate('/mi-dashboard')}
              className="font-bold text-xl text-[#FCAA0D] flex items-center cursor-pointer"
            >
              <span className="hidden sm:inline">INNOTEC</span>
              <span className="inline sm:hidden">IN</span>
              <span className="text-white ml-1">Dashboard</span>
            </div>
          </div>

          {/* Barra de búsqueda */}
          <form onSubmit={handleSearch} className="flex-1 max-w-md hidden md:block">
            <div className="relative">
              <Search className="absolute left-2.5 top-2.5 h-4 w-4 text-zinc-500" />
              <Input
                type="text"
                placeholder="Buscar máquinas, recambios, documentos..."
                className="w-full bg-zinc-800/50 border-zinc-700/50 pl-9 py-2 text-sm focus-visible:ring-[#FCAA0D]/30"
                value={searchQuery}
                onChange={(e) => setSearchQuery(e.target.value)}
              />
            </div>
          </form>

          {/* Acciones rápidas */}
          <div className="flex items-center gap-2">
            <Button
              variant="ghost"
              size="icon"
              className="relative text-zinc-400 hover:text-white hover:bg-zinc-800"
            >
              <Bell className="h-5 w-5" />
              <span className="absolute top-1 right-1 w-2 h-2 bg-[#FCAA0D] rounded-full"></span>
            </Button>

            <Button
              variant="ghost"
              size="icon"
              className="text-zinc-400 hover:text-white hover:bg-zinc-800"
              onClick={() => navigate('/mi-perfil')}
            >
              <Settings className="h-5 w-5" />
            </Button>

            <div className="flex items-center gap-3 ml-2 pl-2 border-l border-zinc-700">
              <Avatar className="cursor-pointer h-8 w-8 hover:ring-2 hover:ring-[#FCAA0D]/30 transition-all">
                <AvatarImage src={userData?.user_metadata?.avatar_url} />
                <AvatarFallback className="bg-[#FCAA0D]/20 text-[#FCAA0D]">
                  {getInitials()}
                </AvatarFallback>
              </Avatar>

              <div className="hidden md:block">
                <div className="text-sm font-medium text-white">
                  {userData?.user_metadata?.name || 'Usuario'}
                </div>
                <div className="text-xs text-zinc-400 truncate max-w-[120px]">
                  {userData?.email}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </header>
  );
}
